import React, { Component } from "react";
import Input from "../common/Input";
import { api, postOptions } from "../common/server";
import { NavLink, Redirect } from "react-router-dom";
import logo from "../assets/rizevoIcon.svg";
import { connect } from "react-redux";
import HomeSvg from "./HomeSvg";

export default connect()(
  class Login extends Component {
    state = {
      redirect: false,
      loading: false,
      errors: {},
    };
    done = () => {
      this.setState({ redirect: "/" });
    };
    login = (ev) => {
      ev.preventDefault();
      this.setState({ errors: {}, loading: true });
      const form = ev.currentTarget;
      // return;
      const formData = {
        email: form.email.value,
        password: form.password.value,
      };
      const body = JSON.stringify(formData);
      fetch(`${api}/login`, Object.assign(postOptions, { body }))
        .then((res) => {
          this.setState({ loading: false });
          return res.json();
        })
        .then((obj) => {
          if (obj.success === false) {
            this.setState({
              errors: { ...this.state.errors, message: obj.message },
            });
          } else if (obj.data.account_type === "personal") {
            localStorage.setItem(
              "rizevo_login_data",
              JSON.stringify({
                data: {
                  token: obj.data.token,
                  account_type: obj.data.account_type
                }
              })
            );
            window.location.href = "/personal";
          } else {
            this.props.dispatch({
              type: "LOGIN_DATA",
              data: {
                data: {
                  token: obj.data.token,
                  account_type: obj.data.account_type
                }
              },
            });

            setTimeout(this.done, 0);
          }
        });
    };
    render() {
      return (
        <div className="login-page-container">
          <div className="login-page-container-header flex">
            <a href="https://kindlybook.com" className="flex co-pink">
              <HomeSvg /> Go to website
            </a>

            <div>
              <NavLink
                to={{
                  pathname: "/signup",
                  search: this.props.location.search,
                }}
                className="default-btn"
              >
                Sign Up
              </NavLink>
            </div>
          </div>
          <div className="form-page login-page">
            {this.state.redirect ? (
              <Redirect
                to={{
                  pathname: `${this.state.redirect}`,
                  search: this.props.location.search,
                }}
              ></Redirect>
            ) : (
              ""
            )}
            <div className="heading">
              <img className="logo" src={logo} alt="" />
              <h1>Kindlybook For Business</h1>
              <p>
                Sign in to manage your bookings, team members, payments and
                more.
              </p>

              <div className="footer dsk">
                Don’t have a Kindlybook account yet?{" "}
                <NavLink
                  to={{
                    pathname: "/signup",
                    search: this.props.location.search,
                  }}
                  className="underline"
                >
                  Create one now
                </NavLink>
              </div>
            </div>

            <div>
              <div className="flex tab-container ">
                {/* <a href="/personal" className="tab inactive">
                  Customer Account
                </a> */}
                {/* <a className="tab">Business Account</a> */}
              </div>
              <div className="form-container card">
                <form onSubmit={this.login}>
                  <Input
                    label="Email address"
                    placeholder="you@example.com"
                    type="email"
                    name="email"
                    autoFocus={true}
                    error={this.state.errors.message}
                    required
                  />
                  <Input
                    label="Password"
                    type="password"
                    name="password"
                    placeholder="Enter password"
                    required
                  />
                  <div className="flex center space-btw">
                    <NavLink to={{ pathname: "/forgot-password" }}
                      className="link underline">
                      Forgot password?
                    </NavLink>
                    <button
                      className={
                        "default " + (this.state.loading ? "loading" : "")
                      }
                    >
                      Sign In
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="footer mbl">
              Don’t have a Kindlybook account yet?{" "}
              <NavLink
                to={{ pathname: "/signup", search: this.props.location.search }}
                className="underline"
              >
                Create one now
              </NavLink>
            </div>
          </div>
        </div>
      );
    }
  }
);
